// @ts-nocheck
import axios from 'axios';
import qs from 'qs';

declare module 'axios' {
  interface AxiosInstance {
    (config: AxiosRequestConfig): Promise<any>;
  }
}

const service = axios.create({
  timeout: 30 * 1000,
});
// 添加请求拦截器
service.interceptors.request.use(
  (config) => {
    if (config.method === 'post') {
      //普通post请求参数处理
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      config.data = qs.stringify(config.data, { indices: false });
      config.paramsSerializer = (params) => {
        //params = params['_'] = (new Date()).getTime();
        return qs.stringify(params, { arrayFormat: 'repeat' });
      };
    } else if (config.method === 'post-json') {
      //post-json请求
      config.method = 'post';
      config.headers['Content-Type'] = 'application/json';
    } else if (config.method === 'post-img') {
      //post-文件上传请求
      config.method = 'post';
      config.headers['Content-Type'] = 'multipart/form-data';
    } else if (config.method === 'post-json-export') {
      //excel-导出
      config.method = 'post';
      config.headers['Content-Type'] = 'application/json';
      config.responseType = 'blob';
    } else if (config.method === 'get-json-export') {
      //excel-导出
      config.method = 'get';
      config.headers['Content-Type'] = 'application/json';
      config.responseType = 'blob';
    } else if (config.method === 'get') {
      config.method = 'get';
      config.baseURL = '';
      try {
        if (config.url.indexOf('ForwardFun') > 0) {
          let urlparams = '';
          if (config.params !== null) {
            //console.log("[params]++++++++++:",config.params);
            for (let key in config.params) {
              //console.log(key+":"+config.params[key]);
              urlparams += '|' + key + '=' + config.params[key];
            }
            config.url = config.url + urlparams;
            config.params = null;
          }
        }
      } catch (e) {
        debugger;
      }
    } else if (config.method === 'get_cross') {
      config.method = 'get';
      config.headers['Access-Control-Allow-Headers'] = 'Content-Type, Content-Length, Authorization, Accept, X-Requested-With , yourHeaderFeild';
      config.baseURL = '';
    }
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject();
  }
);

// 添加响应拦截器
service.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return response.data;
    } else {
      return response;
    }
  },
  (error) => {
    console.log(error);
    return Promise.reject();
  }
);
export default service;
